// extracted by mini-css-extract-plugin
module.exports = {"ConversionPage":"ConversionPage_ConversionPage__3ziSA","menuPanel":"ConversionPage_menuPanel__hrkDv","conversionPanel":"ConversionPage_conversionPanel__35cUV"};